module.exports = require("@mattiasbuelens/web-streams-adapter");